<template>
  <div class="test">
    <div class="save">
      <el-row type="flex">
        <!-- <el-button type="info" @click="saveSvg">SVG</el-button>
        <el-button type="info" @click.prevent="savePng">PNG</el-button> -->
        <el-button :disabled="isPreview" v-if="showSaveButtonForAdmin" type="primary" @click="save">Zapisz</el-button>
        <el-button :disabled="isPreview" v-if="showSendProject" type="success" @click="sendDialogVisible = true">Prześlij</el-button>
      </el-row>
    </div>

      <el-dialog title="Czy wysłać projekt?" :visible.sync="sendDialogVisible" width="20%" :close-on-click-modal="false">
        <span>
          Czy na pewno chcesz przesłać już projekt? Po przesłaniu projektu zostaniemy o tym poinformowani. Jeżeli rozpoczniemy jego realizację to projekt zostanie zablokowany (powiadomimi Cię mailowo) do jakiejkolwiek edycji, upewnij się zatem, że wszystko jest w porządku! Jeśli tak, przesyłaj! Czekamy na Twój projekt :)
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="sendDialogVisible = false">Anuluj</el-button>
          <el-button type="success" @click="send">Prześlij</el-button>
        </span>
      </el-dialog>
      <el-dialog title="Zapisz projekt" :visible.sync="saveDialogVisible" width="20%" :close-on-click-modal="false">
        <el-form ref="form" :model="saveProjectData">
          <el-form-item>
            <el-input placeholder="Imię" v-model="saveProjectData.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="E-mail" v-model="saveProjectData.email"></el-input>
            <small>Na podany adres wyślemy Ci wiadomość e-mail z linkiem do edycji Twojego projektu. Nie wysyłamy SPAMu!</small>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="createProject">Zapisz</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="Zapisz szablon" :visible.sync="saveTemplateDialogVisible" width="20%" :close-on-click-modal="false">
        <el-form ref="form" :model="saveTemplateData">
          <el-form-item>
            <el-input placeholder="Nazwa" v-model="saveTemplateData.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="Kod szablonu" v-model="saveTemplateData.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="Zdjęcie (adres URL)" v-model="saveTemplateData.photo"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="createTemplate">Zapisz</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { canvas } from '../../canvas';
  import md5 from 'md5';

  export default {
    data() {
      return {
        sendDialogVisible: false,
        saveDialogVisible: false,
        saveTemplateDialogVisible: false,
        saveProjectData: {
          name: '',
          hash: '',
          email: '',
          scenes: '',
          orderId: null,
        },
        saveTemplateData: {
          name: '',
          code: '',
          photo: '',
          scenes: '',
        }
      }
    },
    computed: {
      ...mapGetters('creator', [
        'project',
        'activeScene',
        'isPreview'
      ]),
      ...mapGetters('user', [
        'loggedIn',
      ]),
      showSaveButtonForAdmin() {
        return this.loggedIn ? !this.project.hash : true
      },
      showSendProject() {
        if (this.loggedIn) {
          console.log('return');
          return false
        }
        // console.log(JSON.stringify(this.project));
        // console.log(this.project.orderId);
        // console.log(this.project.status == '0');
        // console.log(this.project.orderId && this.project.status == '0');
        return this.project.orderId && this.project.status == '0'
      },
    },
    methods: {
      ...mapActions('creator', {
        setTemplate: 'setTemplate',
        createProjectAction: 'setProject',
        setProjectStatus: 'setProjectStatus',
      }),
      saveSvg() {

        canvas.getObjects().forEach((object) => object.visible = !object.excludeFromSVG);

        const svg = canvas.toSVG();
  
        const blob = new Blob([svg], { type: 'image/svg+xml' });

        // create an URI pointing to that blob
        const url = URL.createObjectURL(blob);
        const win = window.open(url);

        canvas.getObjects().forEach((object) => object.visible = true);
        // var fileLink = document.createElement('a');
        // fileLink.href = url;
        // fileLink.download = `${this.project.orderId}-${this.activeScene + 1}.svg`;
        // fileLink.click();

        // URL.revokeObjectURL(url);

        // so the Garbage Collector can collect the blob
        win.onload = () => URL.revokeObjectURL(url);
      },
      savePng() {

        var png = canvas.toDataURL({ format: 'png' });

        /* Change MIME type to trick the browser to downlaod the file instead of displaying it */
        png = png.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');

        // /* In addition to <a>'s "download" attribute, you can define HTTP-style headers */
        png = png.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=Canvas.png');

        const link = document.querySelector('#png-save')

        link.href = png;
        link.download = 'preview.jpg';
        link.click();
      },
      save() {
        
        if (this.loggedIn) {
          this.saveTemplateDialogVisible = true;
          this.saveTemplateData = Object.assign({}, this.project);
        } else if (this.project.hash) {
          console.log('save user project');
          this.createProject()
        } else {
          this.saveDialogVisible = true
        }
      },
      createTemplate() {
        
        this.setTemplate(this.saveTemplateData)
          .then(() => {
            this.saveTemplateDialogVisible = false;

            this.$notify({
              title: 'OK!',
              message: 'Szablon został pomyślnie zapisany',
              type: 'success',
              position: 'bottom-right'
            });
          })
          .catch(() => {
            this.saveTemplateDialogVisible = false;
            
            this.$notify.error({
              title: 'Ups!',
              message: 'Wystąpił błąd podczas zapisywania szablonu',
              position: 'bottom-right'
            });
          })
      },
      createProject() {
        console.log('createProject');

        if (!this.project.hash) {
          this.saveProjectData.hash = md5(new Date())
          this.saveProjectData.orderId = this.$route.params.orderId || null;
          window.history.pushState({}, '', `/editor/${this.saveProjectData.hash}`);
        } else {
          this.saveProjectData = Object.assign({}, this.project)
        }

        this.saveProjectData.scenes = this.project.scenes;

        return this.createProjectAction(this.saveProjectData)
          .then((response) => {
            this.saveProjectData.id = this.project.id || null
            this.saveDialogVisible = false

            if (response.success) {
              this.$notify({  
                title: 'OK!',
                message: 'Projekt został pomyślnie zapisany',
              });
            } else if (response.locked) {
                this.$alert('Projekt jest w trakcie realizacji, jego edycja jest zablokowana.', 'Ups...', {
                  confirmButtonText: 'OK',
                  type: 'warning',
                });
            }
            
          })
          .catch(() => {
            this.saveDialogVisible = false
            this.$notify.error({
              title: 'Ups!',
              message: 'Wystąpił błąd podczas zapisywania projektu',
              position: 'bottom-right'
            });
          })
      },
      send() {

        console.log('send project');

        this.saveProjectData = Object.assign({}, this.project)
        this.saveProjectData.status = 1;

        return this.createProjectAction(this.saveProjectData)
          .then(() => {
            this.sendDialogVisible = false
            this.$notify({
              title: 'OK!',
              message: 'Projekt został pomyślnie przesłany',
              type: 'success',
              position: 'bottom-right'
            });
          })
          .catch(() => {
            this.sendDialogVisible = false
            this.$notify.error({
              title: 'Ups!',
              message: 'Wystąpił błąd podczas przesyłania projektu',
              position: 'bottom-right'
            });
          })
        // this.createProject()
        //   .then(this.setProjectStatus({ status: 1, hash: this.project.hash }))
        //   .then(() => {
        //     this.sendDialogVisible = false
        //     this.$notify({
        //       title: 'OK!',
        //       message: 'Projekt został pomyślnie przesłany',
        //       type: 'success',
        //       position: 'bottom-right'
        //     });
        //   })
        //   .catch(() => {
        //     this.sendDialogVisible = false
        //     this.$notify.error({
        //       title: 'Ups!',
        //       message: 'Wystąpił błąd podczas przesyłania projektu',
        //       position: 'bottom-right'
        //     });
        //   })
      },
    }
  }
</script>

<style scope lang="less">
  .save {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    padding: 15px 25px;
    width: 350px;
    box-sizing: border-box;
    z-index: 10;
    box-shadow: -1px -1px 2px #e1e1e1;
    .el-row .el-button {
      width: 100%;
    }
  }
</style>
